/* eslint-disable */
if (!window._TL_) {
  window._TL_ = (str: string) => str;
}
var _TL_: (str: string) => string = window._TL_;